import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { useDocumentTitle } from '@/hooks/use-document-title'
import { localizedPageTitle } from '@/lib/page-title'

// All routes-page state lives in the URL so every view is deep-linkable. The
// page content itself renders inside the persistent map (FleetMapView); this
// route only declares the search contract + page title.
const routesSearchSchema = z.object({
  // Active tab. `routeId` (detail) / `edit` / `fromTemplate` override this.
  tab: z.enum(['calculate', 'routes']).optional(),
  // Selected saved route → opens the Routes tab + detail panel.
  routeId: z.coerce.number().optional(),
  // Load an existing route / template into the Calculate form.
  edit: z.coerce.number().optional(),
  fromTemplate: z.coerce.number().optional(),
  // Shared map style/layers (carried over from the old calculate-route page).
  style: z
    .enum([
      'explore',
      'night',
      'logistics',
      'logisticsNight',
      'satellite',
      'terrain',
    ])
    .optional(),
  layers: z.string().optional(),
})

export const Route = createFileRoute('/dashboard/routes/')({
  head: () => ({ meta: [{ title: localizedPageTitle('routes') }] }),
  component: RoutesRoute,
  validateSearch: routesSearchSchema,
})

function RoutesRoute() {
  useDocumentTitle('routes')
  // Content is rendered by FleetMapView (persistent map). Keep the Outlet empty.
  return null
}
